import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CropSetting, CropSettingsState } from '../../cropsetting.model';
import { adapter } from '../reducers/cropsetting.reducer';

const {
  // selectIds,
  selectEntities,
  selectAll,
  // selectTotal
} = adapter.getSelectors();

export const getCropSettingsState = createFeatureSelector<CropSettingsState>('cropSettings');

export const getCropSettingsEntities = createSelector(getCropSettingsState, selectEntities);

export const getCropSettings = createSelector(getCropSettingsState, selectAll);

export const getCropSetting = createSelector(
  getCropSettingsEntities,
  (cropSettings: { [key: string]: CropSetting }, props: { id: string }) => cropSettings[props.id],
);
